import { proxy, useSnapshot } from "valtio";
var _ = require('lodash');

const initialAppState = {
  loaded: false,
  swloaded: false,
  standalone: null,
  installed: null,
  scope: null,
  notified: false,
}

export const appState = proxy(initialAppState);
export function useAppStateSnapshot() { return useSnapshot(appState)}
export const getAppState = () => {return appState};
export const getStateStandalone = () => {return appState.standalone};
export const setStateStandalone = (tf) => {return appState.standalone = tf};
export const getStateInstalled = () => {return appState.installed};
export const setStateInstalled = (tf) => {return appState.installed = tf};
export const getStateSWLoaded = () => {return appState.swloaded};
export const setStateSWLoaded = (tf) => {return appState.swloaded = tf};
export const getStateScope = () => {return appState.scope};
export const setStateScope = (s) => {return appState.scope = s};

export const updateAppState = (as) => { 
  appState.loaded = as.loaded;
  appState.swloaded = as.swloaded;
  appState.standalone = as.standalone;
  appState.installed = as.installed;
  appState.scope = as.scope;
  appState.notified = as.notified;
};

const initialReportState = {
	SubjectName: '',
	SubjectSSN: '',
	SpouseName: '',
	SpouseSSN: '',
	ReportName: '',
	ReportType: '',
  ReportFile: '',
	ReportData: [],
	ReportDoc: null,
	ReportTexts: [],
	loaded: false,
	loadingCount: 0
}

export var reportState = proxy(initialReportState);
export function useReportStateSnapshot() {return useSnapshot(reportState)};
//export function useReportNameSnapshot() {return useSnapshot(reportState.ReportName)};
export const updateReportState = (rs) => { 
	var upd = {
 		...reportState,
		...rs
		};
		reportState = upd;
	};
export const clearReportState = () => {reportState = initialReportState};
export const getReportState = () => {return reportState};
export const getReportType = () => {return reportState.ReportType};
export const setReportType = (s) => {return reportState.ReportType = s};
export const getReportName = () => {return reportState.ReportName};
export const setReportName = (s) => {return reportState.ReportName = s};
export const getReportData = () => {return reportState.ReportData};
export const setReportData = (s) => {return reportState.ReportData = s};
export const getReportDoc = () => {return reportState.ReportDoc};
export const setReportDoc = (s) => {return reportState.ReportDoc = s};
export const getReportTexts = () => {return reportState.ReportTexts};
export const setReportTexts = (s) => {return reportState.ReportTexts = s};

export const getSubjectName = () => {return reportState.SubjectName};
export const setSubjectName = (s) => {return reportState.SubjectName = s};
export const getSubjectSSN = () => {return reportState.SubjectSSN};
export const setSubjectSSN = (s) => {return reportState.SubjectSSN = s};
export const getSpouseName = () => {return reportState.SpouseName};
export const setSpouseName = (s) => {return reportState.SpouseName = s};
export const getSpouseSSN = () => {return reportState.SpouseSSN};
export const setSpouseSSN = (s) => {return reportState.SpouseSSN = s};
export const getStateLoaded = () => {return reportState.loaded};
export const setStateLoaded = (s) => {return reportState.loaded = s};
export const getStateLoadingCount = () => {return reportState.loadingCount};
export const setStateLoadingCount = (s) => {return reportState.loadingCount = s};
export const incStateLoadingCount = () => {return ++reportState.loadingCount};
export const decStateLoadingCount = () => {return --reportState.loadingCount};

